//General services
export const getQueryParts = () => {
    try {
        const qs = new URLSearchParams(window.location.search);
        const sourceId = qs.get("sourceId") || "";
        const affS2 = qs.get("affS2") || "";
        return `${sourceId}-${affS2}`;
    } catch (error) {
        console.error("Error reading query params:", error);
        return "-"; // fallback if parsing fails
    }
};

export const getAffIDs = () => {
    try {
        const qs = new URLSearchParams(window.location.search);
        const affs = {};

        for (let i = 1; i <= 5; i++) {
            const value = qs.get(`affS${i}`);
            if (value) {
                affs[`affS${i}`] = value;
            }
        }
        return affs;
    } catch (error) {
        console.error("Error reading query params:", error);
        return {};
    }
};

export const getLinkID = () => {
    try {
        const qs = new URLSearchParams(window.location.search);
        return qs.get("linkId") || "";

    } catch (error) {
        console.error("Error reading query params:", error);
        return {};
    }
};

export const getSourceID = () => {
    try {
        const qs = new URLSearchParams(window.location.search);
        return qs.get("sourceId") || "";

    } catch (error) {
        console.error("Error reading query params:", error);
        return {};
    }
};


//API
export const searchBusinessApi = async (zip_code, category_id, trusted_form_cert_url, utm_content, utm_subid, utm_campaign) => {
    const res = await fetch(`api/get_pros`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            zip_code, category_id, trusted_form_cert_url, utm_content, utm_subid, utm_campaign
        }),
    });
    if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`);
    }

    return await res.json();
};

export const validateLocationApi = async (zip_code) => {
    const res = await fetch(`/api/test_location`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ zip_code }),
    });

    const data = await res.json().catch(() => null);

    if (!res.ok) {
        throw new Error(data?.detail || data?.message || "Invalid location");
    }

    return data;
};

export const getCID = () => {
    return document.cookie
        .split("; ")
        .find(row => row.startsWith("trackdesk_cid="))
        ?.split("=")[1];
};

export const getSubID = () => {
    const val = document.cookie
        .split("; ")
        .find(row => row.startsWith("trackdesk_subid="))
        ?.split("=")[1];
    return val ? decodeURIComponent(val) : undefined;
};

export const createClickApi = async () => {
    const existingCID = getCID();
    let data;

    if (existingCID) {
        data = { trackdesk_cid: existingCID };
    }
    else {
        const res = await fetch(`/api/create_click`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                link_id: getLinkID(),
                source_id: getSourceID(),
                ...getAffIDs(),
            })
        });

        data = await res.json().catch(() => null);

        if (!res.ok) {
            throw new Error(data?.detail || data?.message || "Failed to create click");
        }

        if (data?.click?.cid) {
            document.cookie = `trackdesk_cid=${data.click.cid}; path=/; max-age=31536000`;
        }

    }

    const subid = [
        getSourceID() || "",
        getAffIDs().affS2 || "",
        getAffIDs().affS3 || "",
        getAffIDs().affS4 || "",
        getAffIDs().affS5 || "",
    ]
        .map(v => String(v).trim())
        .join("-");

    if (subid) {
        document.cookie = `trackdesk_subid=${encodeURIComponent(subid)}; path=/; max-age=31536000`;
    }
    else {
        console.error("could not obtain subid")
    }

    return data;
};